import React from "react";
import Img360 from "../../assets/images/360.png";

const ThreeSixty = React.memo(() => (
  <>
    <div className="fixed left-1/2 bottom-10 transform -translate-x-1/2 z-30 pointer-events-none">
      <img
        src={Img360}
        alt="360"
        className="w-full h-full object-contain drop-shadow-xl"
      />
    </div>
    <div className="fixed left-1/2 bottom-4 transform -translate-x-1/2 z-30 bg-black/40 px-3 pt-1.5 pb-2 rounded-full pointer-events-none max-w-[92%]">
      <p className="text-white text-sm opacity-80 truncate" style={{ textShadow: '0 2px 0.8px rgba(0, 0, 0, 0.25), 1px 2px 4px rgba(0, 0, 0, 0.25), 0 4px 4px rgba(0, 0, 0, 0.25)' }}>Computer Generated Imagery</p>
    </div>
  </>
));

export default ThreeSixty;
